module.exports = __webpack_public_path__ + "static/media/discount.589b5fe6.svg";